import { render, staticRenderFns } from "./AzDistributorsMetadataReadOnlyPanel.vue?vue&type=template&id=67795bde"
import script from "./AzDistributorsMetadataReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./AzDistributorsMetadataReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports